import { Button } from '@strata/react-buttons';
import { WarningDialog } from '@strata/react-dialog';
import { DetailValue } from '@strata/react-label-value-pairs';
import { SuccessToast } from '@strata/react-toast-message';
import PropTypes from 'prop-types';

import { handleError } from 'services/ErrorManagement';
import { httpDelete } from 'services/Http';

export const DeleteRouteRuleDialog = ({
    payerId = undefined,
    segmentId,
    benefit,
    routeRuleToDelete = undefined,
    onDeleteSuccess,
    onClose,
}) => (
    <WarningDialog
        dialogTitle="Confirm Delete"
        width={600}
        isOpen={!!routeRuleToDelete}
        primaryButtonLabel="Yes, Delete Route Rule"
        primaryButtonIntent={Button.Intent.DANGER}
        onPrimaryButtonClick={async () => {
            try {
                await httpDelete(
                    `/clients/admin/${payerId}/${segmentId}/route_rules/${benefit}/${routeRuleToDelete?.route_rule_id}`,
                );

                SuccessToast({
                    message: `${routeRuleToDelete?.route_name} successfully deleted.`,
                });

                onDeleteSuccess();
                onClose();
            } catch (err) {
                handleError(`Error deleting ${routeRuleToDelete?.route_name}.`, err);
            }
        }}
        secondaryButtonLabel="No, Cancel"
        onSecondaryButtonClick={onClose}
        dialogContent={
            <>
                <div className="margin__bottom--large">
                    {routeRuleToDelete?.is_global
                        ? `This will delete the global route from ${segmentId}'s route rules.`
                        : 'Are you sure you want to delete the following Route Rule?'}
                </div>
                <div className="margin__bottom--small">
                    <DetailValue value={routeRuleToDelete?.route_name} />
                </div>
            </>
        }
    />
);

DeleteRouteRuleDialog.propTypes = {
    payerId: PropTypes.string,
    segmentId: PropTypes.string.isRequired,
    benefit: PropTypes.string.isRequired,
    routeRuleToDelete: PropTypes.shape({
        route_rule_id: PropTypes.string.isRequired,
        route_name: PropTypes.string.isRequired,
        is_global: PropTypes.bool,
    }),
    onDeleteSuccess: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired,
};
